import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { API_CONFIG } from '../../../config/api.config';
import {
  PlanesConTarifas,
  TarifaBaseParams,
  TarifaRequest,
  TarifaResponse,
} from '../../../domain/interfaces/tarifa/tarifa.interface';

@Injectable({ providedIn: 'root' })
export class TarifaService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private readonly tarifaUrl = `${environment.apiBaseUrl}${API_CONFIG.ENDPOINTS.TARIFA}`;

  consultarTarifasPlanes(params: TarifaBaseParams): Observable<PlanesConTarifas> {
    return this.authService.getAuthHeaders().pipe(
      switchMap(headers => {
        const planNames = API_CONFIG.PLAN_NAMES;
        // Una sola consulta por plan con paymentFrecuency fijo en 'ANUAL'
        // El backend responde con todos los precios (anual y mensual)
        const calls: Observable<TarifaResponse>[] = planNames.map(plan =>
          this.http.post<TarifaResponse>(
            this.tarifaUrl,
            { ...params, plan, paymentFrecuency: 'ANUAL' } satisfies TarifaRequest,
            { headers },
          ),
        );

        return forkJoin(calls).pipe(
          map(responses => {
            const result: PlanesConTarifas = {};
            planNames.forEach((plan, i) => {
              // La respuesta única contiene todos los precios (anual y mensual)
              // Se asigna a ambas propiedades para mantener compatibilidad
              result[plan] = {
                anual: responses[i],
                mensual: responses[i],
              };
            });
            return result;
          }),
        );
      }),
      catchError(error => {
        console.error('[TarifaService] Error consultando tarifas:', error);
        return throwError(() => error);
      }),
    );
  }
}
